import { render, staticRenderFns } from "./CanceledDeparturesButtons.vue?vue&type=template&id=b9174f46"
import script from "./CanceledDeparturesButtons.vue?vue&type=script&lang=js"
export * from "./CanceledDeparturesButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports